export const DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS = 'set_permission_groups'

export const DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER = 'manager'

export const DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS = 'admin'

export const DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_LANDLORDS = 'landlord'

export const DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_TENANTS = 'dweller'

export const DOCUMENT_EDIT_ACCESS_FIELD_NAME_INHERIT_PERMISSIONS =
  'inherit_permission_groups'

export const DOCUMENT_EDIT_ACCESS_ROLES = [
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_LANDLORDS,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_TENANTS,
]

// Admin > Manager > Landlord/Dweller (IU-647): raising a role bumps the roles
// above it up to the same level, lowering a role pushes the roles below it down
export const DOCUMENT_EDIT_ACCESS_ROLES_HIERARCHY = {
  [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS]: {
    below: [
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER,
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_LANDLORDS,
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_TENANTS,
    ],
  },
  [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_LANDLORDS]: {
    above: [
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS,
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER,
    ],
  },
  [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER]: {
    above: [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS],
    below: [
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_LANDLORDS,
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_TENANTS,
    ],
  },
  [DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_TENANTS]: {
    above: [
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS,
      DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER,
    ],
  },
}
